import CardTemplate from '@/root/components/CardTemplate';
import {Card} from '@/root/models/card';

interface Props {
  card: Card;
  onClick: () => void;
}

const CardOverview = ({card, onClick}: Props) => {
  const {overview} = card;

  return (
    <button type="button" className="item_list" onClick={onClick}>
      <div className="thumb_card" aria-hidden="true">
        <CardTemplate card={card} isThumbnail />
      </div>
      <div className="cont_info">
        <strong className="tit_item">{overview.title}</strong>
        <span className="txt_desc">{overview.section1}</span>
        <span className="txt_desc">{overview.section2}</span>
      </div>
    </button>
  );
};

export default CardOverview;
